import { initializeApp } from 'firebase/app';

export const app = initializeApp({
	apiKey           : 'AIzaSyAcZJ7hGfxYKhkGHJwAnsLS3z5Tg9kWw2s',
	authDomain       : 'facorio-blueprints.firebaseapp.com',
	databaseURL      : 'https://facorio-blueprints.firebaseio.com',
	storageBucket    : 'facorio-blueprints.appspot.com',
	messagingSenderId: '329845993350',
});
